import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "dayjs/locale/ko";
import "intl-tel-input/build/css/intlTelInput.css";
import Router from "./Router";

const queryClient = new QueryClient();

function App() {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      dateFormats={{ monthShort: `M` }}
      adapterLocale="ko">
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </LocalizationProvider>
  );
}

export default App;
